<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;" v-if="this.ifelse != true">
<el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
       <el-form-item :label="formLabelAlign.obj.BillNum" >
       <el-input v-model="formLabelAlign.BillNumt" size="small" :disabled="checked"></el-input>
       <el-checkbox v-model="checked" @change="ChangeChecked">(自动生成编号)</el-checkbox>
    </el-form-item>
       <el-form-item :label="formLabelAlign.obj.BillCopies" >
       <el-input v-model="formLabelAlign.BillCopiest" size="small" disabled></el-input>
    </el-form-item>
       <el-form-item :label="formLabelAlign.obj.StartNum" >
       <el-input v-model="formLabelAlign.startNumt" size="small" :disabled="checked"></el-input>
    </el-form-item>
       <el-form-item :label="formLabelAlign.obj.EndNum" >
       <el-input v-model="formLabelAlign.EndNum" size="small" :disabled="checked"></el-input>
    </el-form-item>
       <el-form-item :label="formLabelAlign.obj.StorageDate" >
       <el-date-picker
      v-model="BillDateTime"
      type="datetime"
      @change="inDateTime()"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
   <el-form-item :label="formLabelAlign.obj.remarks" >
       <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
<div v-else style="width:70%;margin-left:5%;">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
         <el-form-item :label="formLabelAlign.obj.BillType" >
         <el-select  clearable v-model="BillTypevalue" placeholder="请选择票据类型"  size="small" @change="ChargeBillType" >
            <el-option v-for="item in BillTypeList" :key="item.BillTypevalue" :label="item.BillTypelabel" :value="item.BillTypevalue"></el-option>
        </el-select>
         </el-form-item>
       <el-form-item :label="formLabelAlign.obj.BillNum" >
       <el-input v-model="formLabelAlign.BillNumt" size="small"></el-input>
         <div style="color:red; width:600px;font-size:14px" > (提示):票据簿编号规则:票据本编号(字)+每本首张票据号码=票据簿编号</div>
    </el-form-item>
       <el-form-item :label="formLabelAlign.obj.BillCopies" >
       <el-input v-model="formLabelAlign.BillCopiest" size="small"></el-input>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.copies" >
       <el-input v-model="formLabelAlign.copiest" size="small"></el-input>
    </el-form-item>
       <el-form-item :label="formLabelAlign.obj.StartNum" >
       <el-input v-model="formLabelAlign.startNumt" size="small"></el-input>
    </el-form-item>
       <el-form-item :label="formLabelAlign.obj.EndNum" >
       <el-input v-model="formLabelAlign.EndNum" size="small"></el-input>
    </el-form-item>
       <el-form-item :label="formLabelAlign.obj.StorageDate" >
       <el-date-picker
      v-model="BillDateTime"
      type="datetime"
      @change="inDateTime()"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
   <el-form-item :label="formLabelAlign.obj.remarks" >
       <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "BillStorageDialog",
  data() {
    return {
    ifelse:true,
    checked: true,
    options:[],
    value:"",
    BillDateTime:"",
    optionsone: [],
    valueone: '',
    dialogVisible: false,
    title:"标题",
    titleone:"",
    labelPosition:'right',
    formLabelAlign:{},
    type:"",
    mangroupId:"",
    Pid:"",
    mangroupName:"",
    typeId:"",
    typeName:"",
    groupId:"",
    BillTypeList:[],
    BillTypevalue:"",
    };
  },
  methods: {
    inDateTime(){
      // console.log(this.BillDateTime)
 let date = this.BillDateTime;
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
            let hh = date.getHours()
            let mf = date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes()
            let ss = date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds()
	    	let arr = ['星期天','星期一','星期二','星期三','星期四','星期五','星期六'];
	    	let day = date.getDay();
            let time = year+"-"+month+"-"+dates+" "+hh+":"+mf+":"+ss
            this.BillDateTime = time
    },
      ChargeBillType(){

      },
      ChangeChecked(){
          if(this.checked == false){
              this.formLabelAlign.BillNumt = ""
              this.formLabelAlign.startNumt = ""
          }else{
              this.formLabelAlign.BillNumt = "<保存时自动生成编号>"
              this.formLabelAlign.startNumt = "(格式：00000000)"
          }
      },
    ChargeBillManTree(){
        for(let val of this.options){
          if(val.value == this.value){
            this.Pid = val.Pid
            this.mangroupName = val.label
          }
        }
    },

    modification(){
        if(this.title == "修改"){
        }else if(this.title == "票据信息"){
            if(this.titleone == "批量"){
                  let obj = {
                   "groupNo":this.formLabelAlign.BillNumt,
                   "typeName":this.typeName,
                   "typeId":this.BillTypevalue,
                   "many":this.formLabelAlign.copiest,
                   "everyNums":this.formLabelAlign.BillCopiest,
                   "startNum":this.formLabelAlign.startNumt,
                   "endNum":this.formLabelAlign.EndNum,
                   "inDate":this.BillDateTime,
                   "groupId":this.groupId,
                   "remarks":this.formLabelAlign.remarks,
                }
            this.$http.post(this.$requestUrl.POST_BATCH_STORAGE,obj).then((res) => {
            let result = res.data;
              if (200 === result.code) {
                 this.dialogVisible = false
                this.$emit("dialog",false)
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
            }else{
            if(this.checked == true){
              this.formLabelAlign.BillNumt = ""
              this.formLabelAlign.startNumt = ""
              this.formLabelAlign.EndNum = ""
          }
               let obj = {
                   "groupNo":this.formLabelAlign.BillNumt,
                   "typeName":this.typeName,
                   "typeId":this.typeId,
                   "everyNums":this.formLabelAlign.BillCopiest,
                   "startNum":this.formLabelAlign.startNumt,
                   "endNum":this.formLabelAlign.EndNum,
                   "inDate":this.BillDateTime,
                   "groupId":this.groupId,
                   "remarks":this.formLabelAlign.remarks,
                }
            this.$http.post(this.$requestUrl.POST_STORAGE_ADD,obj).then((res) => {
            let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
                this.$emit("dialog",false)
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
            }
        }


    },
    handleClose(done) {
      this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
      if(this.formLabelAlign.obj == undefined){
            let obj = {
            "BillNum":"票据本编号(字)",
            "BillCopies":"每本份数",
            "StartNum":"起始号码",
            "EndNum":"终止号码",
            "StorageDate":"入库日期",
            "remarks":"备注信息",
            "BillType":"票据类型",
            "copies":"本数",
          }
          this.osData = []
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>